import { Search } from 'lucide-react'
import styles from './SearchInput.module.css'

type Props = {
  placeholder: string
  value: string
  setValue: (value: string) => void
}


export default function SearchInput({placeholder, value, setValue} : Props) {
  return (
    <div className={styles.container}>
        <input value={value} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.currentTarget.value)}
              className={styles.search} type="text" placeholder={placeholder}/>
        <Search className={styles.icon}/>
    </div>
  )
}
